/**
 * @generated SignedSource<<b15ca654c8a6527ecdbeff3107d083e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsTeamListItem_Team$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "KPIEditSectionsTeamListItem_Team";
};
export type KPIEditSectionsTeamListItem_Team$key = {
  readonly " $data"?: KPIEditSectionsTeamListItem_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsTeamListItem_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIEditSectionsTeamListItem_Team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "7532a911dcfc95987734540b00a77f85";

export default node;
